import { Click } from "./Click";
import Render from "./Render";

export * from "./types";

export const Guard = Object.assign({}, {
  Click,
  Render
})